import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField, Modal } from '@mui/material'
import { RootState } from '../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from './SettingsStyles'
import { AddITAdminSettings } from '../../actions/api/fetchITAdmin'
import { getITAdminSettingsData } from '../../actions'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { DialogContentText } from '@mui/material'

export default function AddProcedureCodeDialog({ open, handleClose }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { userLogin } = useSelector((state: RootState) => state.userLogin)
  const [pathologyCode, setPathologyCode] = useState('')
  const [cdxCode, setCdxCode] = useState('')
  const [description, setDescription] = useState('')
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [ppcChanged, setPPCChanged] = useState(false)
  const [cpcChanged, setCPCChanged] = useState(false)
  const [descriptionChanged, setDescriptionChanged] = useState(false)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [disableSubmit, setDisableSubmit] = useState(true)
  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn}`)
  const { add_procedure_code_success, add_procedure_code_error, add_duplicate_procedure_code } = useSelector(
    (state: RootState) => state.addSettingResponse,
  )

  const handleCloseDialog = (type) => {
    if (type === 'confirm') {
      setPathologyCode('')
      setCdxCode('')
      setDescription('')
    }
    setOpenDialog(false)
  }
  const onCancel = (e) => {
    if (ppcChanged || cpcChanged || descriptionChanged) {
      setOpenDialog(true)
    } else {
      handleClose()
    }
  }

  const onChangeData = (e, type) => {
    if (type === 'ppc') {
      setPathologyCode(e.target.value)
      setPPCChanged(true)
    } else if (type === 'cpc') {
      setCdxCode(e.target.value)
      setCPCChanged(true)
    } else if (type === 'desc') {
      setDescription(e.target.value)
      setDescriptionChanged(true)
    }
  }

  useEffect(() => {
    if (pathologyCode && cdxCode && description && pathologyCode !== '' && cdxCode !== '' && description !== '') {
      setDisableSubmit(false)
    } else {
      setDisableSubmit(true)
    }
  }, [pathologyCode, cdxCode, description])

  const handleSubmit = async () => {
    const AddParameters = {
      cdx_procedure_code: cdxCode,
      pathology_procedure_code: pathologyCode,
      description: description.replaceAll("'", "''"),
    }
    await dispatch(AddITAdminSettings({ payload: AddParameters }))
    await setOpenSuccessSnackBar(true)
    await updateDataTable()
  }

  const updateDataTable = () => {
    dispatch(getITAdminSettingsData({ id: `${userLogin}` }))
    setTimeout(closeModal, 100)
    setTimeout(() => setOpenSuccessSnackBar(false), 4000)
    setPathologyCode('')
    setCdxCode('')
    setDescription('')
  }

  const closeModal = handleClose
  const SuccessMessage = `Add Procedure Code operation successful`
  const ErrorMessage = `Add Procedure Code operation failed`
  const ErrorDuplicateMessage = 'Entered Procedure Code already exist in the System'
  return (
    <React.Fragment>
      <div>
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.discardDialogHeight }}
        >
          <DialogTitle className={classes.dialogTitle}>Discard Changes</DialogTitle>
          <DialogContent className={classes.discardDialogContent}>
            <DialogContentText id="alert-dialog-description">
              You have pending unsaved changes. Do you really want to discard them?
            </DialogContentText>
          </DialogContent>

          <DialogActions className={classes.buttonActions}>
            <Button
              className={`${classes.btn} ${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('confirm')
                handleClose()
              }}
              autoFocus
              endIcon={<CheckIcon />}
            >
              Confirm
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              onClick={function (event) {
                handleCloseDialog('cancel')
              }}
              variant="outlined"
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        {add_procedure_code_success && openSuccessSnackBar && <SuccessSnackBar message={SuccessMessage} />}
        {add_procedure_code_error && openSuccessSnackBar && <ErrorSnackBar message={ErrorMessage} />}
        {add_duplicate_procedure_code && openSuccessSnackBar && <ErrorSnackBar message={ErrorDuplicateMessage} />}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className={`${classes.mt} , ${classes.mb}`}>
            <Dialog
              fullWidth
              maxWidth="sm"
              id="hello"
              classes={{ paper: classes.dialogHeight }}
              open={open}
              onClose={handleClose}
            >
              <DialogTitle className={classes.dialogTitle}>Add Procedure Code</DialogTitle>
              <Divider />
              <DialogContent>
                <Box component="form" autoComplete="off">
                  <div className={classes.TextField}>
                    <TextField
                      className={classes.TextBox}
                      label="Pathology Procedure Code*"
                      type="number"
                      variant="outlined"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                      }}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onChange={(event) => onChangeData(event, 'ppc')}
                      defaultValue={''}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      className={classes.TextBox}
                      label="CDx Procedure Code*"
                      type="number"
                      variant="outlined"
                      inputProps={{
                        style: {
                          padding: 10,
                        },
                        min: 1,
                      }}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault()
                        }
                      }}
                      onChange={(event) => onChangeData(event, 'cpc')}
                      defaultValue={''}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      className={classes.TextBoxDescription}
                      label="Description*"
                      multiline
                      maxRows={4}
                      variant="outlined"
                      onChange={(event) => onChangeData(event, 'desc')}
                      defaultValue={''}
                      InputLabelProps={{ shrink: true }}
                    />
                  </div>
                </Box>
              </DialogContent>
              <DialogActions className={classes.buttonActions}>
                <Button onClick={handleSubmit} className={getClassNames()} endIcon={<CheckIcon />}>
                  Submit
                </Button>
                <Button
                  onClick={onCancel}
                  color="primary"
                  variant="outlined"
                  style={{ width: '115px' }}
                  endIcon={<ClearIcon />}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  )
}
